( function () {
	'use strict';

	/* @ngInject */
	function addEvidences ( $q, coreservice, $modal, EVDICONS ) {
		function link ( scope ) {
			scope.icons = EVDICONS;

			var evidenceTypes = [ {
				'template'   : '/templates/components/evidences/text/evidence-text.html',
				'controller' : 'AddEditTextController'
			}, {
				'template'   : '/templates/components/evidences/timer/add-edit.html',
				'controller' : 'AddEditTimerController'
			}, {
				'template'   : '/templates/components/evidences/counter/add-edit.html',
				'controller' : 'AddEditCounterController'
			}, {
				'template'   : '/templates/components/evidences/file/evidence-file.html',
				'controller' : 'ObsFileController'
			} ];

			function addEvidence ( type ) {
				var evidenceType     = 0;
				// 3 - document  5 -image
				var fileEvidenceType = [ 3, 5 ];

				if ( type === 7 ) {
					evidenceType = 1;
				}  else if ( type === 6 ) {
					evidenceType = 2;
				} else if ( fileEvidenceType.indexOf( type ) > -1 ) {
					evidenceType = 3;
				}

				$modal.open( {
					'templateUrl'  : evidenceTypes[ evidenceType ].template,
					'controller'   : evidenceTypes[ evidenceType ].controller,
					'controllerAs' : 'vm',
					'windowClass'  : 'modal fade in',
					'resolve'      : {
						'evidence' : function () {
							return null;
						},

						'evidenceType' : function () {
							return type;
						},

						'observation' : function () {
							return scope.observation;
						},

						'level' : function () {
							return scope.level;
						},

						'isTemplatePreview' : function () {
							return scope.isTemplatePreview;
						},

						'allowedFileFormats' : function () {
							return scope.allowedFileFormats;
						}
					}
				} );
			}

			scope.addEvidence = addEvidence;
		}

		var directive = {
			'link'        : link,
			'restrict'    : 'E',
			'templateUrl' : '/templates/components/evidences/pool/add-evidences.html',
			'scope'       : {
				'observation'        : '=',
				'level'              : '=',
				'update'             : '&',
				'isTemplatePreview'  : '=',
				'allowedFileFormats' : '='
			}
		};

		return directive;
	}

	angular
		.module( 'app.components' )
		.directive( 'addEvidences', addEvidences );

	addEvidences.$inject = [ '$q', 'coreservice', '$modal', 'EVDICONS' ];
} )( );
